var _excluded = ["snapped", "tooltip", "values", "max", "maxLabel", "min", "minLabel", "theme"],
    _excluded2 = ["ref", "index"],
    _excluded3 = ["ref", "index"];

var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import { bool, string, number, arrayOf, shape, oneOfType } from 'prop-types';
import styled, { withTheme } from 'styled-components';
import RCSlider from 'rc-slider/lib/Slider';
import RCRange from 'rc-slider/lib/Range';
import Marker from './Marker';
var StyledSlider = styled(RCSlider)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n\n  ", "\n\n  * {\n    box-sizing: border-box;\n  }\n"])), function (_ref) {
  var marks = _ref.marks;
  return "\n    padding-bottom: " + (marks ? 40 : 15) + "px;\n  ";
});
var StyledRange = styled(RCRange)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n\n  ", "\n\n  * {\n    box-sizing: border-box;\n  }\n"])), function (_ref2) {
  var marks = _ref2.marks;
  return "\n    padding-bottom: " + (marks ? 40 : 15) + "px;\n  ";
});
/** Sliders allow users to make selections from a range of values. Sliders
reflect a range of values along a bar, from which users may select a single
value. They are ideal for adjusting settings such as volume, brightness, or
applying image filters. */

var Slider = function Slider(_ref3) {
  var _ref4, _ref6;

  var snapped = _ref3.snapped,
      tooltip = _ref3.tooltip,
      values = _ref3.values,
      max = _ref3.max,
      maxLabel = _ref3.maxLabel,
      min = _ref3.min,
      minLabel = _ref3.minLabel,
      slider = _ref3.theme.yoga.components.slider,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded);

  var styles = {
    commonTrackStyle: {
      borderRadius: slider.track.border.radius,
      height: 4,
      position: 'absolute',
      width: '100%'
    },
    trackStyle: {
      backgroundColor: slider.track.backgroundColor.active
    },
    railStyle: {
      backgroundColor: slider.track.backgroundColor.inactive
    },
    commonStepStyle: {
      borderRadius: slider.step.border.radius,
      marginLeft: -4,
      position: 'absolute',
      height: 10,
      top: -3,
      width: 10
    },
    activeStepStyle: {
      backgroundColor: slider.track.backgroundColor.active
    },
    inactiveStepStyle: {
      backgroundColor: slider.track.backgroundColor.inactive
    },
    labelStyle: {
      position: 'absolute',
      top: 15
    }
  };
  return values.length > 1 ? /*#__PURE__*/React.createElement(StyledRange, _extends({}, props, {
    dots: snapped,
    value: values,
    allowCross: false,
    marks: (_ref4 = {}, _ref4[min] = {
      label: minLabel,
      style: _extends({}, styles.labelStyle, {
        transform: 'translateX(0%)'
      })
    }, _ref4[max] = {
      label: maxLabel,
      style: _extends({}, styles.labelStyle, {
        transform: 'translateX(-100%)'
      })
    }, _ref4),
    trackStyle: [_extends({}, styles.commonTrackStyle, styles.trackStyle)],
    railStyle: _extends({}, styles.commonTrackStyle, styles.railStyle),
    dotStyle: snapped ? _extends({}, styles.commonStepStyle, styles.inactiveStepStyle) : undefined,
    activeDotStyle: snapped ? _extends({}, styles.commonStepStyle, styles.activeStepStyle) : undefined,
    max: max,
    min: min,
    handle: function handle(_ref5) {
      var ref = _ref5.ref,
          index = _ref5.index,
          rest = _objectWithoutPropertiesLoose(_ref5, _excluded2);

      return /*#__PURE__*/React.createElement(Marker, _extends({
        values: values,
        tooltip: tooltip,
        key: index,
        index: index
      }, rest));
    }
  })) : /*#__PURE__*/React.createElement(StyledSlider, _extends({}, props, {
    prefixCls: "yoga",
    dots: snapped,
    value: values[0],
    marks: (_ref6 = {}, _ref6[min] = {
      label: minLabel,
      style: _extends({}, styles.labelStyle, {
        transform: 'translateX(0%)'
      })
    }, _ref6[max] = {
      label: maxLabel,
      style: _extends({}, styles.labelStyle, {
        transform: 'translateX(-100%)'
      })
    }, _ref6),
    trackStyle: _extends({}, styles.commonTrackStyle, styles.trackStyle),
    railStyle: _extends({}, styles.commonTrackStyle, styles.railStyle),
    dotStyle: snapped ? _extends({}, styles.commonStepStyle, styles.inactiveStepStyle) : undefined,
    activeDotStyle: snapped ? _extends({}, styles.commonStepStyle, styles.activeStepStyle) : undefined,
    max: max,
    min: min,
    handle: function handle(_ref7) {
      var ref = _ref7.ref,
          index = _ref7.index,
          rest = _objectWithoutPropertiesLoose(_ref7, _excluded3);

      return /*#__PURE__*/React.createElement(Marker, _extends({
        values: values,
        tooltip: tooltip,
        key: index,
        index: index
      }, rest));
    }
  }));
};

Slider.propTypes = {
  /** set the max value */
  max: number,

  /** label to be displayed at max value */
  maxLabel: oneOfType([string, number]),

  /** set the min value */
  min: number,

  /** label to be displayed at min value */
  minLabel: oneOfType([string, number]),

  /** make slider be snap through dots */
  snapped: bool,

  /** accepts a shape with 'ribbon', 'title', 'description', 'visible' and 'step' properties */
  tooltip: arrayOf(shape({
    ribbon: string,
    title: string,
    description: string,
    visible: bool,
    step: number
  })),

  /** an array that accepts one or two numbers, this determines how many markers will be displayed */
  values: arrayOf(number)
};
Slider.defaultProps = {
  max: 10,
  maxLabel: undefined,
  min: 0,
  minLabel: undefined,
  snapped: false,
  tooltip: [],
  values: [0]
};
Slider.displayName = 'Slider';
export default withTheme(Slider);